<template lang="pug">
  .component-vehicle-attributes-action-buttons
    button.button.warning(type="button", v-on:click="remove") Delete
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from 'src/maggieHelper'

  export default {
    name: 'VehicleAttributeButtons',
    components: {},
    data() {
      return {
        entity: null
      }
    },
    created() {
    },
    methods: {
      remove: function () {
        this.$confirm('Are you sure?', `Do you really want to <strong>Remove</strong> the <strong>VA${this.item.id} attribute?</strong>`, () => {
          KeplerBackofficeSdk.vehicleAttributes.select(this.item).remove(() => {
            MaggieHelper.notification('delete-esit', 'Attribute removed')
            window.location.reload()
          })
        })
      },
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// VehicleAttributeButtons.vue?2572fa38